import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { translateTracksBasedOnLanguage } from '../../Util/translator';
import { handleMixTrayGlobal, setIsMixSaved, setMixSavedId, setSharingTracks } from '../../Store/Slices/SaveMixSlice';
import { addMultipleTracks, addPlaylistTracks, playAllTracks, removeAllTracks, resetConfig, setConfig, setPlayingConfig, setPlayingId, setSelectedItem, togglePlayPause } from '../../Store/Slices/PlayerSlice';
import { activeUser } from '../../Store/Slices/APIs';
import { crossIcon, MinusIconEmpty, PauseButton, PlayButton, ShareIcon } from '../../Assets/svg'
import { Modal } from 'react-bootstrap';
import { flattenSoundMixtureTracks, InitPlaylistTrackingIds } from '../../Util/helpers';
import { handleShareMixModal } from '../../Store/Slices/ModalSlice';

const MyMixStrip = ({ item, openShareMixModal, deleteMyMix }) => {

    const dispatch = useDispatch();
    const tracks = useSelector((state) => state.player.playingTracks);
    const config = useSelector((state) => state.player.config);
    const isPlaying = useSelector((state) => state.player.isPlaying);
    const userPrompts = useSelector((state) => state.user.userPrompts);
    const isMixerTrayOpen = useSelector((state) => state.mixStatus.isMixerTrayOpen);

    const [isSelected, setIsSelected] = useState(false);
    const [isDeleteMixModal, setIsDeleteMixModal] = useState(false);

    useEffect(() => {
        if (config?.type === "mix" || config?.type === "playlist") {
            setIsSelected(config['id'] === item.id);
        } else {
            setIsSelected(tracks.some(t => t.id === item.id));
        }
    }, [tracks, item.id]);

    const { t, i18n } = useTranslation();

    const handlePlayPause = async () => {

        // Update mix state
        dispatch(setIsMixSaved(false));
        dispatch(setMixSavedId(null));

        // Active User
        dispatch(activeUser());
        dispatch(removeAllTracks());

        if (!isSelected) {
            let data = flattenSoundMixtureTracks(item);

            // Smart translation based on UI language and track languages
            if (Array.isArray(data) && data.length > 0) {
                data = await translateTracksBasedOnLanguage(data, i18n?.language);
            }
            const playingId = data[0]['id'];
            const isPlaylist = item?.isPlaylist;
            const playlist_type = item?.playlist_type;


            const filtered = item?.sounds_list?.filter(s => {
                // for playlist mixes, only consider sounds for auto play logic. for user created mixes, consider all types
                if (playlist_type === "music_lullaby") {
                    return s.sounds_detail?.[0]?.type !== 'sounds';
                } else {
                    return s.sounds_detail?.[0]?.type === 'sounds' && (s.sounds_detail?.[0]?.soundcategory === 163 || s.sounds_detail?.[0]?.soundcategory === 164);
                }
            });

            const obj = {
                id: item?.id,
                type: isPlaylist ? 'playlist' : 'mix',
                name: item?.title ?? item?.name,
                data: data,
                playingId: isPlaylist ? playingId : null,
                restartId: null,
                isRepeat: item?.repeat ?? false,
                isShuffle: item?.shuffle ?? false,
                isPlaylist: false,
                isPlaylistMix: isPlaylist,
                shouldPlay: filtered[0]?.sound,
                playlist_type: isPlaylist ? playlist_type : "default",
            }
            dispatch(setMixSavedId(item?.id));
            dispatch(setConfig(obj));
            setTimeout(() => {
                if (isPlaylist) InitPlaylistTrackingIds(data[0]?.id);
                // set playing tracks from the prepared detail objects
                dispatch(addPlaylistTracks({ data }));
                dispatch(playAllTracks(true));
                if (isMixerTrayOpen) dispatch(handleMixTrayGlobal(true));
            });
        } else {
            dispatch(togglePlayPause());
        }

    };

    const handleShareMixModals = async () => {
        let tracks = flattenSoundMixtureTracks(item);

        if (Array.isArray(tracks) && tracks.length > 0) {
            tracks = await translateTracksBasedOnLanguage(tracks, i18n?.language);
        }

        dispatch(setMixSavedId(item.id));
        dispatch(setSelectedItem(tracks))
        dispatch(handleShareMixModal(true));
    }

    const openDeleteMixModal = () => {
        dispatch(setMixSavedId(null));
        dispatch(setSharingTracks({ item: [] }))
        setIsDeleteMixModal(true);
    }

    const handleDeleteMyMix = () => {
        setIsDeleteMixModal(false);
        deleteMyMix(item?.id)
    }




    return (
        <>
            <div className='mixer-pallete mb-2 mb-sm-3 p-2 p-sm-2'>
                <button className='btn p-2 mx-sm-3 me-sm-4' onClick={handlePlayPause}>
                    <img src={isPlaying && isSelected ? PauseButton : PlayButton} className='play-icon' />
                </button>
                <div className="mixer-gradient">
                    {item?.sounds_list?.slice(0, 3).map((soundThmb, index) => (
                        <div className='mixerSoundThumbnail' key={index}>
                            <img src={soundThmb?.image.startsWith('/media/assets') ? 'https://storage.googleapis.com/relax_dev/assets' + soundThmb?.image.split('/media/assets')[1] : soundThmb?.image} />
                        </div>
                    ))}
                </div>
                <div className='flex-grow-1'>
                    <h5 className='mb-0 ps-3 ps-sm-4 fw-light mixer-name'>{item?.name}</h5>
                </div>
                <div className='flex-shrink-0'>
                    <button className='btn p-2 mb-1' onClick={handleShareMixModals}>
                        <img src={ShareIcon} className='share-icon' />
                    </button>
                </div>
                <div className='flex-shrink-0 ms-2 mx-sm-3' onClick={openDeleteMixModal}>
                    <button className='btn p-2'>
                        <img src={MinusIconEmpty} className='heart-icon' />
                    </button>
                </div>
            </div>

            {/* delete modal */}
            <Modal
                show={isDeleteMixModal}
                centered
                className="soundModal"
                backdrop="static"
            >
                <Modal.Body>
                    <div className="text-end">
                        <button
                            className="closeButton notButton ms-auto"
                            onClick={() => setIsDeleteMixModal(false)}
                        >
                            <img src={crossIcon} alt="" />
                        </button>
                    </div>
                    <div className="customModalContent my-5">
                        <h2 className="font-16 lh-16 fw-normal mb-5 text-center">{userPrompts?.delete_mix}</h2>
                        <div className="mt-4 d-flex align-items-center justify-content-center">
                            <button style={{ backgroundColor: '#ffffff1f' }} className='mx-3 px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={handleDeleteMyMix}>
                                <span className=''>{t("playlists.yes")}</span>
                            </button>
                            <button style={{ backgroundColor: '#ffffff1f' }} className='mx-3 px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={() => setIsDeleteMixModal(false)}>
                                <span className=''>{t("playlists.no")}</span>
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )

}

export default MyMixStrip
